var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled from 'styled-components';
import { Header4 } from './typography';
import Undraw from './undraw';
import Link from './link';
var Spinner = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @keyframes wheel {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes colors {\n    0% {\n      background-position: 0% 50%;\n      transform: rotate(0deg);\n    }\n    50% {\n      background-position: 100% 50%;\n    }\n    100% {\n      background-position: 0% 50%;\n      transform: rotate(360deg);\n    }\n  }\n\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  border-radius: 50%;\n  background-clip: content-box;\n  animation-iteration-count: infinite;\n  animation-timing-function: cubic-bezier(0.42, 0.25, 0.58, 0.75);\n"], ["\n  @keyframes wheel {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n\n  @keyframes colors {\n    0% {\n      background-position: 0% 50%;\n      transform: rotate(0deg);\n    }\n    50% {\n      background-position: 100% 50%;\n    }\n    100% {\n      background-position: 0% 50%;\n      transform: rotate(360deg);\n    }\n  }\n\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  border-radius: 50%;\n  background-clip: content-box;\n  animation-iteration-count: infinite;\n  animation-timing-function: cubic-bezier(0.42, 0.25, 0.58, 0.75);\n"])));
var PrimaryRing = styled(Spinner)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  animation-duration: 1000ms;\n  animation-name: wheel;\n  border-top: 6px solid ", ";\n  border-left: 0px solid transparent;\n  border-right: 0px solid transparent;\n  height: 100%;\n"], ["\n  animation-duration: 1000ms;\n  animation-name: wheel;\n  border-top: 6px solid ", ";\n  border-left: 0px solid transparent;\n  border-right: 0px solid transparent;\n  height: 100%;\n"])), function (p) {
  return p.theme.primary;
});
var SecondaryRing = styled(Spinner)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  animation-duration: 750ms;\n  animation-name: wheel;\n  border-top: 6px solid ", ";\n  border-left: 0px solid transparent;\n  border-right: 0px solid transparent;\n  height: 100%;\n"], ["\n  animation-duration: 750ms;\n  animation-name: wheel;\n  border-top: 6px solid ", ";\n  border-left: 0px solid transparent;\n  border-right: 0px solid transparent;\n  height: 100%;\n"])), function (p) {
  return p.theme.secondary;
});
var TertiaryRing = styled(Spinner)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  animation-duration: 500ms;\n  animation-name: wheel;\n  border-top: 6px solid ", ";\n  border-left: 0px solid transparent;\n  border-right: 0px solid transparent;\n  height: 100%;\n"], ["\n  animation-duration: 500ms;\n  animation-name: wheel;\n  border-top: 6px solid ", ";\n  border-left: 0px solid transparent;\n  border-right: 0px solid transparent;\n  height: 100%;\n"])), function (p) {
  return p.theme.tertiary;
});
var GradientBall = styled(Spinner)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  animation: colors 2s cubic-bezier(0.42, 0.25, 0.58, 0.75) infinite;\n  background-image: linear-gradient(90deg, ", ", ", ");\n  background-size: 300% 300%;\n  height: 100%;\n"], ["\n  animation: colors 2s cubic-bezier(0.42, 0.25, 0.58, 0.75) infinite;\n  background-image: linear-gradient(90deg, ", ", ", ");\n  background-size: 300% 300%;\n  height: 100%;\n"])), function (p) {
  return p.theme.secondary;
}, function (p) {
  return p.theme.tertiary;
});
var RoundWrapper = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: inline-block;\n  font-size: ", "rem;\n  height: 1em;\n  position: relative;\n  width: 1em;\n"], ["\n  display: inline-block;\n  font-size: ", "rem;\n  height: 1em;\n  position: relative;\n  width: 1em;\n"])), function (p) {
  return p.size * 3;
});
var BounceDot = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  @keyframes bounceDots {\n    0% {\n      left: 0.55em;\n      transform: scale(0.75, 1.25);\n    }\n    15% {\n      left: 0.55em;\n      transform: scale(1, 1);\n    }\n    85% {\n      left: -0.05em;\n      transform: scale(1, 1);\n    }\n    100% {\n      left: -0.05em;\n      transform: scale(0.75, 1.25);\n    }\n  }\n\n  position: relative;\n  top: 25%;\n  border-radius: 50%;\n  height: 0.5em;\n  width: 0.5em;\n  animation: bounceDots 500ms linear infinite alternate;\n  overflow: visible;\n"], ["\n  @keyframes bounceDots {\n    0% {\n      left: 0.55em;\n      transform: scale(0.75, 1.25);\n    }\n    15% {\n      left: 0.55em;\n      transform: scale(1, 1);\n    }\n    85% {\n      left: -0.05em;\n      transform: scale(1, 1);\n    }\n    100% {\n      left: -0.05em;\n      transform: scale(0.75, 1.25);\n    }\n  }\n\n  position: relative;\n  top: 25%;\n  border-radius: 50%;\n  height: 0.5em;\n  width: 0.5em;\n  animation: bounceDots 500ms linear infinite alternate;\n  overflow: visible;\n"])));
var BounceDotPrimary = styled(BounceDot)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  animation-delay: -250ms;\n  background-color: ", ";\n"], ["\n  animation-delay: -250ms;\n  background-color: ", ";\n"])), function (p) {
  return p.theme.primary;
});
var BounceDotSecondary = styled(BounceDot)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  animation-delay: -750ms;\n  background-color: ", ";\n"], ["\n  animation-delay: -750ms;\n  background-color: ", ";\n"])), function (p) {
  return p.theme.secondary;
});
var BounceDotTertiary = styled(BounceDot)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  animation-delay: -1250ms;\n  background-color: ", ";\n"], ["\n  animation-delay: -1250ms;\n  background-color: ", ";\n"])), function (p) {
  return p.theme.tertiary;
});
var BounceDotQuaternary = styled(BounceDot)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  animation-delay: -1750ms;\n  background-color: ", ";\n"], ["\n  animation-delay: -1750ms;\n  background-color: ", ";\n"])), function (p) {
  return p.theme.quaternary;
});
var PushDot = styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  @keyframes pushDots {\n    0% {\n      left: -0.5em;\n    }\n    20% {\n      left: calc(50%);\n    }\n    40% {\n      left: calc(50%);\n    }\n    100% {\n      left: calc(100% + 5em);\n    }\n  }\n\n  position: absolute;\n  top: 25%;\n  border-radius: 50%;\n  height: 0.5em;\n  width: 0.5em;\n  animation: pushDots 2000ms linear infinite;\n  overflow: visible;\n"], ["\n  @keyframes pushDots {\n    0% {\n      left: -0.5em;\n    }\n    20% {\n      left: calc(50%);\n    }\n    40% {\n      left: calc(50%);\n    }\n    100% {\n      left: calc(100% + 5em);\n    }\n  }\n\n  position: absolute;\n  top: 25%;\n  border-radius: 50%;\n  height: 0.5em;\n  width: 0.5em;\n  animation: pushDots 2000ms linear infinite;\n  overflow: visible;\n"])));
var PushDotPrimary = styled(PushDot)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  animation-delay: -400ms;\n  background-color: ", ";\n"], ["\n  animation-delay: -400ms;\n  background-color: ", ";\n"])), function (p) {
  return p.theme.primary;
});
var PushDotSecondary = styled(PushDot)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  animation-delay: -900ms;\n  background-color: ", ";\n"], ["\n  animation-delay: -900ms;\n  background-color: ", ";\n"])), function (p) {
  return p.theme.secondary;
});
var PushDotTertiary = styled(PushDot)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  animation-delay: -1400ms;\n  background-color: ", ";\n"], ["\n  animation-delay: -1400ms;\n  background-color: ", ";\n"])), function (p) {
  return p.theme.tertiary;
});
var PushDotQuaternary = styled(PushDot)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  animation-delay: -1900ms;\n  background-color: ", ";\n"], ["\n  animation-delay: -1900ms;\n  background-color: ", ";\n"])), function (p) {
  return p.theme.quaternary;
});
var PullDot = styled(PushDot)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  animation: pushDots 2000ms linear infinite reverse;\n"], ["\n  animation: pushDots 2000ms linear infinite reverse;\n"])));
var PullDotPrimary = styled(PullDot)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  animation-delay: -400ms;\n  background-color: ", ";\n"], ["\n  animation-delay: -400ms;\n  background-color: ", ";\n"])), function (p) {
  return p.theme.primary;
});
var PullDotSecondary = styled(PullDot)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  animation-delay: -900ms;\n  background-color: ", ";\n"], ["\n  animation-delay: -900ms;\n  background-color: ", ";\n"])), function (p) {
  return p.theme.secondary;
});
var PullDotTertiary = styled(PullDot)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  animation-delay: -1400ms;\n  background-color: ", ";\n"], ["\n  animation-delay: -1400ms;\n  background-color: ", ";\n"])), function (p) {
  return p.theme.tertiary;
});
var PullDotQuaternary = styled(PullDot)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  animation-delay: -1900ms;\n  background-color: ", ";\n"], ["\n  animation-delay: -1900ms;\n  background-color: ", ";\n"])), function (p) {
  return p.theme.quaternary;
});
var DotWrapper = styled.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n  float: left;\n  height: 1em;\n  width: 1em;\n"], ["\n  float: left;\n  height: 1em;\n  width: 1em;\n"])));
var BounceWrapper = styled.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  display: inline-block;\n  font-size: ", "rem;\n  height: 1em;\n  position: relative;\n  width: 4em;\n"], ["\n  display: inline-block;\n  font-size: ", "rem;\n  height: 1em;\n  position: relative;\n  width: 4em;\n"])), function (p) {
  return p.size;
});
var PushWrapper = styled.div(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n  display: inline-block;\n  font-size: ", "rem;\n  height: 1em;\n  position: relative;\n  overflow: hidden;\n  width: 4em;\n"], ["\n  display: inline-block;\n  font-size: ", "rem;\n  height: 1em;\n  position: relative;\n  overflow: hidden;\n  width: 4em;\n"])), function (p) {
  return p.size;
}); // Loader components

var RingLoader = function RingLoader(_a) {
  var size = _a.size;
  return React.createElement(RoundWrapper, {
    className: "loader loader-ring",
    size: size
  }, React.createElement(TertiaryRing, null), React.createElement(SecondaryRing, null), React.createElement(PrimaryRing, null));
};

var GradientLoader = function GradientLoader(_a) {
  var size = _a.size;
  return React.createElement(RoundWrapper, {
    className: "loader loader-gradient",
    size: size
  }, React.createElement(GradientBall, null));
};

var AtomLoader = function AtomLoader(_a) {
  var size = _a.size;
  return React.createElement(RoundWrapper, {
    className: "loader loader-atom",
    size: size
  }, React.createElement(TertiaryRing, null), React.createElement(SecondaryRing, null), React.createElement(PrimaryRing, null), React.createElement(GradientBall, {
    style: {
      width: '.5em',
      height: '.5em',
      top: '25%',
      left: '25%'
    }
  }));
};

var BounceLoader = function BounceLoader(_a) {
  var size = _a.size;
  return React.createElement(BounceWrapper, {
    className: "loader loader-bounce",
    size: size
  }, React.createElement(DotWrapper, null, React.createElement(BounceDotPrimary, null)), React.createElement(DotWrapper, null, React.createElement(BounceDotSecondary, null)), React.createElement(DotWrapper, null, React.createElement(BounceDotTertiary, null)), React.createElement(DotWrapper, null, React.createElement(BounceDotQuaternary, null)));
};

var PushLoader = function PushLoader(_a) {
  var size = _a.size;
  return React.createElement(PushWrapper, {
    className: "loader loader-push",
    size: size
  }, React.createElement(PushDotPrimary, null), React.createElement(PushDotSecondary, null), React.createElement(PushDotTertiary, null), React.createElement(PushDotQuaternary, null));
};

var PullLoader = function PullLoader(_a) {
  var size = _a.size;
  return React.createElement(PushWrapper, {
    className: "loader loader-pull",
    size: size
  }, React.createElement(PullDotPrimary, null), React.createElement(PullDotSecondary, null), React.createElement(PullDotTertiary, null), React.createElement(PullDotQuaternary, null));
}; // Consolidated Loader components


var Loader = function Loader(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'atom' : _b,
      _c = _a.size,
      size = _c === void 0 ? 3 : _c;

  switch (variant) {
    case 'bounce':
      return React.createElement(BounceLoader, {
        size: size
      });

    case 'gradient':
      return React.createElement(GradientLoader, {
        size: size
      });

    case 'push':
      return React.createElement(PushLoader, {
        size: size
      });

    case 'pull':
      return React.createElement(PullLoader, {
        size: size
      });

    case 'ring':
      return React.createElement(RingLoader, {
        size: size
      });

    case 'atom':
    default:
      return React.createElement(AtomLoader, {
        size: size
      });
  }
};

var Wrapper = styled.div(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])));
var StyledLink = styled(Link)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n  margin-top: 2em;\n"], ["\n  margin-top: 2em;\n"])));

var LoaderImage = function LoaderImage(_a) {
  var message = _a.message,
      image = _a.image;
  return React.createElement(Wrapper, null, React.createElement(Header4, null, message), React.createElement(Undraw, {
    image: image
  }), React.createElement(StyledLink, {
    to: "/"
  }, "Return Home"));
};

export var AsyncLoader = function AsyncLoader(_a) {
  var children = _a.children,
      emptyMessage = _a.emptyMessage,
      failureMessage = _a.failureMessage,
      empty = _a.empty,
      failed = _a.failed,
      _b = _a.loading,
      loading = _b === void 0 ? React.createElement(Wrapper, null, React.createElement(Loader, null)) : _b,
      request = _a.request;
  var emptyFragment = empty !== undefined ? empty : React.createElement(LoaderImage, {
    message: emptyMessage !== undefined ? emptyMessage : "There's nothing here.",
    image: "empty"
  });
  var failedFragment = failed !== undefined ? failed : React.createElement(LoaderImage, {
    message: failureMessage !== undefined ? failureMessage : 'Something went wrong.',
    image: "felix-update"
  });

  if (request.isLoading) {
    return loading;
  } else if (request.hasFailed) {
    return failedFragment;
  } else if (request.hasFinished && request.isEmpty) {
    return emptyFragment;
  } else if (request.hasFinished && !request.isEmpty) {
    return React.createElement(React.Fragment, null, children);
  } else {
    return null;
  }
};
export default Loader;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26;